import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";

const Result = ({selectedCampaign,history}) => {
    useEffect(() => {
        if (selectedCampaign === undefined) {
            history.push("/Home/SmartCalculation");
        }
    }, []);

    return (
              <div className="container-fluid">
              {/* yesil Alan*/}
              <div className="row" style={{ padding: "3%" }}>
                  <div className="col-12">
                      {/* KUTU 1 */}
                      <div className="row no-gutters t-kutu t-yesilCizgi">
                          <div
                              className="col bosluk backtop"
                              style={{
                                  backgroundImage: 'url("/assets/img/backgrounds/back_top_yesil.jpg")'
                              }}
                          >
                              {/* içerikler */}
                              <div className="row no-gutters pb-4">
                                  <div className="col-12 d-flex justify-content-center pb-2">
                                      <i className="t-icon-bubble1 t-icGenelBaslikIconYesil" />
                                  </div>
                                  <div className="col-12 d-flex justify-content-center pb-3 t-icGenelBaslikYesil">
                                  Talebiniz Alınmıştır.
                                  </div>
                                  <div className="col-12 text-center t-icYazilar20pt">
                                  İlginize teşekkür ederiz. Sözleşmeniz en kısa zamanda adresinize gönderilecektir.
                                  <br></br>
                                  <Link to="/Home/MemberInfo">Buraya tıklayarak Üyeliklerinize ulaşabilirsiniz.</Link>
                                  </div>
                              </div>
                              {/* içerikler BİTTİ */}
                          </div>
                          <div className="col-auto renk" />
                      </div>
                      {/* KUTU 1 BİTTİ */}
                  </div>
              </div>
              {/* Duyurlar Baslık*/}
              {/* duyrular Bitti*/}
              <div className="row" style={{ height: 30 }} />
          </div>
    );
}

const mapStateToProps = (state) => ({
    selectedCampaign: state.calculation.selectedCampaign
});

export default compose(
    withRouter,
    connect(mapStateToProps)
)(Result);